var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"basic-button ma-2",class:[_vm.size, { 'no-events': _vm.loading }, { reverse: _vm.reverse }],style:(_vm.styles),attrs:{"elevation":"0","type":_vm.type,"loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.label)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }